/**
 * Task #21 — external learner has clicked the unsubscribe link on a
 * renewal-reminder email. The backend has stamped both the certificate
 * row and the underlying contact_profile so no further reminders go
 * out for any course; this page is just the "we heard you" terminus.
 */
export function LearnerOptedOutPage(): JSX.Element {
  return (
    <div className="max-w-md mx-auto p-12 text-center space-y-3">
      <h1 className="text-2xl font-semibold">You're unsubscribed</h1>
      <p className="text-sm text-ink-muted">
        You won't receive any more training renewal reminders from us.
        If you change your mind, contact the organization that enrolled
        you and they can re-enable reminders for your account.
      </p>
    </div>
  );
}
